import { __rest } from '../node_modules/tslib/tslib.es6.js';
import React, { useMemo, createContext } from 'react';

function createCustomContext(contextName, defaultContextValue) {
  const Context = /*#__PURE__*/createContext(defaultContextValue);
  function Provider(props) {
    const {
        children
      } = props,
      otherProps = __rest(props, ["children"]);
    const value = useMemo(() => otherProps, Object.values(otherProps));
    return /*#__PURE__*/React.createElement(Context.Provider, {
      value: value
    }, children);
  }
  const useContext = () => {
    const context = React.useContext(Context);
    if (!context) {
      throw new Error("You forgot to wrap your component with ".concat(contextName));
    }
    return context;
  };
  return [Provider, useContext];
}

export { createCustomContext as default };
